import React from "react";
import {useTranslation} from "react-i18next";

import Card from "@mui/material/Card";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import {COLORS} from "../../../../../config/constants";

import './support-plan-card.scss'

type SupportPlanCardRow = {
  label: React.ReactNode
  value: React.ReactNode
}

type Props = {
  rows?: SupportPlanCardRow[]
  title?: React.ReactNode
}

const SupportPlanCard = ({rows, title}: Props) => {

  const { t } = useTranslation();
  const hasCustomContent = Boolean(title || rows?.length);

  return (
    <Card className='support-plan-card'>
      <div className='support-plan-card__header'>
        <Typography
          variant='h6'
          className='support-plan-card__title'
          sx={{fontSize: '18px', fontWeight: 500, letterSpacing: 0, lineHeight: '24px', whiteSpace: 'nowrap'}}
        >
          {title || (
            <>
              {t('support__text__level')}{' '}
              «
              <Link underline='always' sx={{color: COLORS.BLUE, cursor: 'pointer'}}>{t('support__text__basicLevel')}</Link>
              »
            </>
          )}
        </Typography>
      </div>
      {hasCustomContent ? (
        <div className='support-plan-card__details'>
          {rows?.map((row, index) => (
            <div key={index} className='support-plan-card__resource-row'>
              <Typography
                variant='caption'
                className='support-plan-card__resource-label'
                sx={{
                  background: COLORS.WHITE,
                  color: COLORS.MEDIUM_GRAY,
                  letterSpacing: 0,
                  lineHeight: '16px',
                  paddingRight: '4px',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {row.label}
              </Typography>
              <Typography
                variant='caption'
                component='div'
                className='support-plan-card__resource-value'
                sx={{
                  background: COLORS.WHITE,
                  color: COLORS.BLACK,
                  letterSpacing: 0,
                  lineHeight: '16px',
                  paddingLeft: '4px',
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {row.value}
              </Typography>
            </div>
          ))}
        </div>
      ) : (
        <div className='support-plan-card__resources'>
          <div className='support-plan-card__resource-row'>
            <Typography
              variant='caption'
              className='support-plan-card__resource-label'
              sx={{
                background: COLORS.WHITE,
                color: COLORS.MEDIUM_GRAY,
                letterSpacing: 0,
                lineHeight: '16px',
                paddingRight: '4px',
                position: 'relative',
                zIndex: 1,
              }}
            >
              {t('support__text__useful')}
            </Typography>
            <Link
              variant='caption'
              underline='always'
              className='support-plan-card__resource-link'
              sx={{
                background: COLORS.WHITE,
                color: COLORS.BLUE,
                cursor: 'pointer',
                letterSpacing: 0,
                lineHeight: '16px',
                paddingLeft: '4px',
                position: 'relative',
                zIndex: 1,
              }}
            >
              {t('support__text__regulations')}
            </Link>
          </div>
        </div>
      )}
    </Card>
  );
};

export default SupportPlanCard;
